import _ from 'underscore';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { UrlEditorWithValidation } from './url-editor';

export function UrlEditorForArray(props) {
  const [url, setUrl] = useState(_.first(props.value[props.field]));
  const urlSchema = {
    properties: {
      url: {
        ...props.schema.properties[props.field],
        type: 'string',
      },
    },
  };

  const onUrlChange = (newUrl) => {
    setUrl(newUrl);
    const urls = newUrl ? [newUrl] : [];
    props.onChange({
      [props.field]: urls,
    });
  };

  return (
    <UrlEditorWithValidation
      {..._.omit(props, 'urls', 'onChange')}
      url={url}
      onChange={onUrlChange}
      validationProps={{
        schema: urlSchema,
        field: 'url',
        data: { url },
      }}
    />
  );
}

UrlEditorForArray.propTypes = {
  value: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    properties: PropTypes.shape({}),
  }).isRequired,
  field: PropTypes.string.isRequired,
};

UrlEditorForArray.defaultProps = {
  value: undefined,
};
